import { usePageContext } from '@providers/PageMetaProvider/model/PageContext';
import { GenerationProgressDashboard } from '@shared/components/GenerationProgressDashboard';
import { useGenerationProgress } from '@shared/hooks/useGenerationProgress';

/**
 * @description Progress dashboard for Deposition Summary generation.
 * Replaces the old simple loading modal with real-time progress tracking.
 */

function DepositionSummaryGeneratingModal() {
  const { values, setValues } = usePageContext();

  // All three popups are always mounted and share generatingDocumentId, so
  // each one only tracks it while its own popup is open. Otherwise the demand
  // popup asked /document-instances/<report id>/progress/ for every report
  // (ZLAYT-1514).
  const documentId = values?.generateDepositionSummaryModalOpened
    ? values?.generatingDocumentId || ''
    : '';
  const documentType = values?.generatingDocumentType || 'Deposition Summary';
  const autoMinimize = values?.progressModalAutoMinimize;
  const expandedSignal = values?.progressModalExpandedAt;

  const progressData = useGenerationProgress(documentId, {
    enableSnapshot: false,
    enablePolling: false,
    enableSynthetic: false,
    pipeline: 'deposition_summary',
  });

  const onClose = () => {
    if (setValues) {
      setValues((prev) => ({
        ...prev,
        generateDepositionSummaryModalOpened: false,
        generatingDocumentId: undefined,
        generatingDocumentType: undefined,
        progressModalAutoMinimize: true,
        progressModalExpandedAt: undefined,
      }));
    }
  };

  // Don't render if modal is not opened or no document ID
  if (!values?.generateDepositionSummaryModalOpened || !documentId) {
    return null;
  }

  return (
    <GenerationProgressDashboard
      documentId={documentId}
      documentType={documentType}
      {...progressData}
      onClose={onClose}
      autoMinimize={autoMinimize}
      expandedSignal={expandedSignal}
    />
  );
}

export default DepositionSummaryGeneratingModal;
